import { css } from "styled-components";

export type ActionVariant = "primary" | "secondary" | "ghost" | "danger";
export const controlStyle = css`
  width: 100%;
  min-width: 0;
  min-height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  padding: 12px 14px;
  background: ${({ theme }) => theme.colors.input};
  color: ${({ theme }) => theme.colors.text};
  font: inherit;
  font-size: 16px;
  line-height: 1.5;
  transition:
    border-color 0.18s,
    box-shadow 0.18s,
    background 0.18s;
  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
    opacity: 1;
  }
  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.borderLight};
  }
  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primarySoft};
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;
export const actionStyle = css<{ $variant?: ActionVariant }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 44px;
  min-width: 0;
  padding: 11px 17px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.surfaceHover};
  color: ${({ theme }) => theme.colors.text};
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.4;
  text-align: center;
  cursor: pointer;
  transition:
    background 0.18s,
    border-color 0.18s,
    box-shadow 0.18s,
    transform 0.18s;
  svg {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
  }
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.border};
    border-color: ${({ theme }) => theme.colors.textMuted};
  }
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 3px;
  }
  ${({ $variant, theme }) =>
    $variant === "primary" &&
    css`
      background: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      color: ${theme.colors.onPrimary};
      box-shadow:
        0 3px 12px #0003,
        inset 0 1px 0 #ffffff30;
      &:hover:not(:disabled) {
        background: ${theme.colors.primaryHover};
        border-color: ${theme.colors.primaryHover};
        box-shadow: 0 4px 22px ${theme.colors.primarySoft};
      }
    `}
  ${({ $variant, theme }) =>
    $variant === "ghost" &&
    css`
      background: transparent;
      border-color: transparent;
      color: ${theme.colors.textSecondary};
      &:hover:not(:disabled) {
        border-color: ${theme.colors.border};
        background: ${theme.colors.surfaceHover};
      }
    `}
  ${({ $variant, theme }) =>
    $variant === "danger" &&
    css`
      background: ${theme.colors.dangerSoft};
      border-color: #ee737340;
      color: ${theme.colors.danger};
      &:hover:not(:disabled) {
        background: #ee73732b;
        border-color: ${theme.colors.danger};
      }
    `}
  /* Кнопка-ссылка (as="a" / as={Link}) не должна наследовать цвет ссылок страницы. */
  &&&,
  &&&:hover {
    text-decoration: none;
    color: ${({ $variant, theme }) =>
      $variant === "primary"
        ? theme.colors.onPrimary
        : $variant === "ghost"
          ? theme.colors.textSecondary
          : $variant === "danger"
            ? theme.colors.danger
            : theme.colors.text};
  }
  &:disabled {
    background: ${({ theme }) => theme.colors.surfaceHover};
    border-color: ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.textMuted};
    box-shadow: none;
    cursor: not-allowed;
    transform: none;
  }
  &&&:disabled {
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;
